export default __webpack_public_path__ + "static/media/gallery_09.6f73da7d.jpg";